/* Winefields - stepper de quantidade nos cards de produto */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-wf-qty]') : null;
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.parentNode;
    var input = wrap.querySelector('.wf-qty__input');
    if (!input) return;
    var value = parseInt(input.value, 10);
    if (isNaN(value)) value = 1;
    value += parseInt(btn.getAttribute('data-wf-qty'), 10);
    if (value < 1) value = 1;
    input.value = value;
  });
})();
